import * as types from './mutation-types'

export const getStockLocation= ({ commit }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stock/location/list').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const getDownloadStockState = ({ commit }, query) => {
  const { location_ids, ...restQuery } = query;
  const params = new URLSearchParams({
    location_type: restQuery.location_type ?? '',
    location_name: restQuery.location_name ?? '',
    on_alert: restQuery.on_alert ? 1 : 0,
    critical: restQuery.critical ? 1 : 0,
    out_of_stock: restQuery.out_of_stock ? 1 : 0,
  });

 
    if(location_ids) {
        location_ids.forEach(id => params.append('location_ids[]', id));
    }

    if(query.page) {
        params.append('page', query.page);
    }

  return new Promise((resolve, reject) => {
    window.axios.get(
      `get/stock/pdf?${params.toString()}`,
      { responseType: 'blob' }
    )
    .then(response => resolve(response))
    .catch(err => reject(err));
  });
}


export const loadStockState = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/stock/list/datatable', {params: data})
            .then((response) => {
                resolve(response)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

export const loadScrollStock = ({ commit, dispatch, state }, query) => {
    const { location_ids, ...restQuery } = query;
    const params = new URLSearchParams(restQuery);

    if(location_ids) {
        location_ids.forEach(id => params.append('location_ids[]', id));
    }

    if(query.page) {
        params.append('page', query.page);
    }

    return new Promise((resolve, reject) => {
        window.axios.get('get/stock/list/datatable?' + params.toString())
            .then(response => {
                commit(types.ADD_SCROLL_STOCK_DATA, {
                    data: response.data,
                    query: params.toString()
                });
                resolve(response);
            })
            .catch(err => reject(err));
    });
}


export const loadNextlStock = ({ commit, dispatch, state }, {search, filter}) => {
    let url = `get/stock/list/datatable?filter=${filter}&search=${search}&after=${state.contactScroll.map(contact => contact.id)}`
    return new Promise((resolve, reject) => {
        window.axios.get(url).then((response) => {
            commit(types.ADD_NEXT_STOCK, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}